const tabs = {
  InterviewFormList: () => import('@/views/researches/Interview/Form')
}

const state = {
  currentInterviewFormTab: tabs.InterviewFormList,
  tabs: tabs
}

const mutations = {
  SET_TABS: (state, tab) => {
    state.currentInterviewFormTab = state.tabs[tab]
  }
}

const actions = {
  setInterviewFormTabs ({ commit }, tab) {
    commit('SET_TABS', tab)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
